import classNames from 'classnames';
import { useHelpCenterFactsheetLink } from 'hooks/use-help-center-factsheet-link';
import { useTranslation } from 'hooks/useTranslation';
import { ProductVariation, ProductVariationBase } from 'models/productsReferential';
import { ComponentProps, ReactNode } from 'react';

type Props = {
  product: ProductVariation | ProductVariationBase;
  icon?: ReactNode;
} & ComponentProps<'a'>;

export function ProductFactsheetLink({ product, icon, onClick, className, ...props }: Props) {
  const link = useHelpCenterFactsheetLink(product.productType, product.productSubType);
  const label = useTranslation('learnMore.factsheet');

  if (!link) {
    return null;
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    onClick?.(e);
  };

  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      onClick={handleClick}
      aria-label={label}
      title={label}
      className={classNames(`btn btn-flat-secondary btn-icon`, className)}
      {...props}
    >
      {icon || (
        <i className="icon icon-outlined" aria-hidden="true">
          text_snippet
        </i>
      )}
    </a>
  );
}
